import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared/shared.module';

@Component({
  selector: 'ig-file-selector',
  templateUrl: './file.selector.component.html',
  styleUrl: './file.selector.component.scss',
})
export class FileSelectorComponent {
  @Input() public sizeLimit = 1024 * 1024 * 2;
  @Input() public command: any;
  @Input() public selectedImageData: string;
  @Input() public isSmallIcon: boolean;
  @Input() public disabled: boolean;
  @Input() public multiple: boolean = false;
  @Input() public accept: string =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
  @ViewChild('imageSelector') public imageSelector: ElementRef;
  @Output() public onRead = new EventEmitter<any>();
  public isShowUploadingSpinner = false;

  public separator = ',';

  public ngOnInit() {}

  public records: any[] = [];

  uploadListener($event: any): void {
    const files = $event.srcElement.files;
    this.onRead.emit(files);
    return;
  }
}
